export const regexp = {
  date_mask:
    '^(?:(?:31(/|-|.)(?:0?[13578]|1[02]))\x011|(?:(?:29|30)(/|-|.)(?:0?[13-9]|1[0-2])\x012))(?:(?:1[6-9]|[2-9]d)?d{2})$|^(?:29(/|-|.)0?2\x013(?:(?:(?:1[6-9]|[2-9]d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1d|2[0-8])(/|-|.)(?:(?:0?[1-9])|(?:1[0-2]))\x014(?:(?:1[6-9]|[2-9]d)?d{2})$',
  password_regex: /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/,
};
